
export enum FormElementStatus {
    Success,
    Default,
    Warning,
    Error,
}

interface ILiteEvent<T> {
    on(handler: { (data?: T): void }): void;
    off(handler: { (data?: T): void }): void;
}

class LiteEvent<T> implements ILiteEvent<T> {
    private handlers: { (data?: T): void; }[] = [];

    public on(handler: { (data?: T): void }): void {
        this.handlers.push(handler);
    }

    public off(handler: { (data?: T): void }): void {
        //this.handlers = this.handlers.filter(h => h !== handler);
        this.handlers = [];
    }

    public trigger(data?: T) {
        this.handlers.slice(0).forEach(h => h(data));
    }

    public expose(): ILiteEvent<T> {
        return this;
    }
}

export class ValidationResult {
    constructor(status: FormElementStatus, message: string) {
        this.status = status;
        this.message = message;
    }
    status: FormElementStatus;
    message: string;
}

export interface IValidatingObject {
    message: string;
    status: FormElementStatus;
    StatusChanged: ILiteEvent<FormElementStatus>;
}


export class FormElementValidator<T> implements IValidatingObject {
    private readonly statusChanged = new LiteEvent<FormElementStatus>();
    public message: string;
    public status: FormElementStatus;
    public get StatusChanged() { return this.statusChanged.expose(); }

    isMandatory: boolean;
    private _validators: ((value: T) => ValidationResult)[];

    constructor(isMandatory: boolean, ...validators: ((value: T) => ValidationResult)[]) {

        this.status = FormElementStatus.Default;
        this.isMandatory = isMandatory;
        this._validators = validators;
        this.message = "";
    }

    public validate(value: T): boolean {
       

        if (this.isMandatory) {
            //console.log("Checking mandatory value : " + value);
            if (!value) {
                //console.log("Value is empty : " + !value);
                this.status = FormElementStatus.Error;
                this.message = "This field is mandatory";
                this.statusChanged.trigger(this.status);
                return false;
            }
        }

        
        var status = FormElementStatus.Success;
        var message = "";
        for (let test of this._validators) {
            var result = test(value);
            if (status < result.status) {
                status = result.status;
                message = message + result.message + " "
            }
            //console.log("Running Validator : " + this._validators.length, result , message);
        }


        //console.log("Validating FormElementValidator Status : " + status + " " + message)

        if (status != this.status || this.message != message) {
            this.status = status;
            this.message = message;
            this.statusChanged.trigger(this.status);
            console.log("Returning " + (this.status != FormElementStatus.Error))
            return this.status != FormElementStatus.Error;
        }

        var result = new ValidationResult(FormElementStatus.Success, "");
        if (result.status != this.status) {
            this.status = result.status;
            this.message = result.message;
            this.statusChanged.trigger(this.status);

            return this.status != FormElementStatus.Error;
        }

        return true;
    }
}


//export class FormValidator implements IValidatingObject {
//    private readonly statusChanged = new LiteEvent<FormElementStatus>();
//    public message: string;
//    public status: FormElementStatus;
//    public get StatusChanged() { return this.statusChanged.expose(); }


//    public validators: IValidatingObject[];
    
//    constructor(...validators: IValidatingObject[]) {
//        this.validators = validators;
//        this.status = FormElementStatus.Success;
//        this.message = "";
//        for (let v of validators) {
//            v.StatusChanged.on((data) => { FormValidator.Update(this, data); });
//        }
//    }

//    private static Update(that: FormValidator, status?: FormElementStatus) {
//        if (that) {
//            that.status = FormElementStatus.Success;
//            for (let v of that.validators) {
//                if (v.status == FormElementStatus.Error) {
//                    that.status = FormElementStatus.Error;
//                    that.message = "Clear all errors";
//                    that.statusChanged.trigger(that.status);
//                    return;
//                }
//            }
//        }
//    }

//    get hasError(): boolean {
//        return this.status == FormElementStatus.Error;
//    }

//    get hasWarning(): boolean {
//        return this.status == FormElementStatus.Warning;
//    }
//}



export class FormPageValidator implements IValidatingObject{
   
    public readonly statusChanged = new LiteEvent<FormElementStatus>();
    public message: string;
    public status: FormElementStatus;
    public get StatusChanged() { return this.statusChanged.expose(); }

    private pageName: string = "";
    public validators: IValidatingObject[];

    constructor(pageName: string = "") {
        this.pageName = pageName;
        this.status = FormElementStatus.Success;
        this.message = "";
    }

    public addValidators(...validators: IValidatingObject[]) {
        this.validators = validators;
        for (let v of validators) {
            v.StatusChanged.on((data) => { FormPageValidator.Update(this, data); });
        }
    }

    public addValidatorsArray(validators: IValidatingObject[]) {
        this.validators = validators;
        for (let v of validators) {
            v.StatusChanged.on((data) => { FormPageValidator.Update(this, data); });
        }
    }

    public addValidator(validator: IValidatingObject) {
        this.validators.push(validator);
        validator.StatusChanged.on((data) => { FormPageValidator.Update(this, data); });
    }

    public removeValidator(validator: IValidatingObject) {
        var index = this.validators.indexOf(validator, 0);
        if (index > -1) {
            this.validators.splice(index, 1);
        }

        validator.StatusChanged.off((data) => { FormPageValidator.Update(this, data); });

        // Once the handler is removed - update the status as this validator could be the one causing the error
        FormPageValidator.Update(this, FormElementStatus.Success);
    }

    protected static Update(that: FormPageValidator, status?: FormElementStatus) {
        //console.log("Form Page Update " + that.pageName + " " + that.status+" " + (status ? status.toString() : "No Status"))
        if (that) {
            var originalStatus = that.status;
            that.status = FormElementStatus.Success;
            that.message = "";
            for (let v of that.validators) {
                if (v.status == FormElementStatus.Error) {
                    that.status = FormElementStatus.Error;
                    that.message = "Clear all errors";
                    break;
                }
            }



            if (originalStatus != that.status) {
                //console.log("Triggering update of that")
                that.statusChanged.trigger(that.status);
            } 
        }
    }

    public SetStatus(status: FormElementStatus, message: string) {
        this.message = message;
        if (this.status != status) {
            this.status = status;
            this.statusChanged.trigger(this.status);
        }
    }

    protected validate(): boolean {

        FormPageValidator.Update(this, FormElementStatus.Success)
        var result = this.isValid();
        //console.log("Runnign validate for .." + this.pageName + " : " + result)
        return result;
    }

    public isValid(): boolean {
        for (var property in this) {
            if (this.hasOwnProperty(property)) {
                var prop: any = this[property];
                if (prop instanceof FormElementController || prop instanceof FormPageValidator) {
                    var formElementController = prop as IFormElementController;
                    formElementController.validate();
                }
            }
        }


        return !this.hasError;
    }
    

    get hasError(): boolean {
        return this.status == FormElementStatus.Error;
    }

    get hasWarning(): boolean {
        return this.status == FormElementStatus.Warning;
    }
}


class ObjectCreator {
    static createEntity<TEntity>(type: { new (): TEntity; }): TEntity {
        return new type();
    }


}

export interface IFormElementController {
    validate(): boolean;
}
export class FormElementController<T> implements IFormElementController {

    public name: string;
    public placeholder: string;
    public validator: FormElementValidator<T>

    public _value: T;
    private mask: (v: T) => T;

    constructor(name: string, val: T, validator?: FormElementValidator<T>, mask?: (v: T)=> T) {
        this.name = name;
        if (validator) {
            this.validator = validator;
        }
        this._value = val;
        if (mask) {
            this.mask = mask;
        }
    }
    public validate() : boolean {
        if (this.validator) {
            return this.validator.validate(this._value);
        }
        return true;
    }

    get value(): T {
        return this._value;
    }

    set value(val: T) {
        if (this.mask) {
            //console.log("Value of " + this.name + " changed to " + val, this._changeHandler);
            val = this.mask(val);
            //console.log("Value of " + this.name + " changed to " + val, this._changeHandler);
        }
        this._value = val;
        //console.log("Value of " + this.name + " changed to " + val, this._changeHandler);

        if (this._changeHandler) {
            //console.log("Value of " + this.name + " changed to " + val, this._changeHandler);
            this._changeHandler(val);
        }

        if (this.validator) {
            this.validator.validate(val);
        }
    }

    private _changeHandler: (val: T) => void

    public OnChange(handler: (val: T) => void) {
        this._changeHandler = handler;
    }


    get hasError(): boolean {
        if (this.validator) {
            return this.validator.status == FormElementStatus.Error;
        }
        return false;
    }
    set hasError(val: boolean) {
        this.validator.status = FormElementStatus.Error;
    }
    get hasWarning(): boolean {
        if (this.validator) {
            return this.validator.status == FormElementStatus.Warning;
        }
        return false;
    }
    set hasWarning(val: boolean) {
        this.validator.status = FormElementStatus.Warning;
    }

    get message(): string {
        if (this.validator) {
            if (this.hasWarning || this.hasError) {
                return this.validator.message;
            }
        }
        return "";
    }
}


export class StringValidators {
    public static MinLength(length: number): (val: string) => ValidationResult {
        return (val: string) => {
            if (val.length < length) {
                return new ValidationResult(FormElementStatus.Error, "Minimum Length is " + length);
            };
            return new ValidationResult(FormElementStatus.Success, "");
        }
    }
}


// WEBPACK FOOTER //
// ./ClientApp/scripts/formcontrols.ts